import { overlay } from 'overlay-kit';

import { RenameCampaignDialog } from './rename-campaign-dialog';

export function requestRenameCampaignDialog({
  initialName,
  onSave,
}: {
  initialName: string;
  onSave: (campaignName: string) => Promise<void>;
}): Promise<void> {
  return overlay.openAsync<void>(({ isOpen, close, unmount }) => (
    <RenameCampaignDialog
      initialName={initialName}
      isOpen={isOpen}
      onCancel={close}
      onSave={async (campaignName) => {
        await onSave(campaignName);
        close();
      }}
      onUnmount={unmount}
    />
  ));
}
